<form [formGroup]="information">
    <div class="form-row">
        <div class="form-group col-md-4 col-sm-12">
            <label for="dateOnLot">Date on Lot</label>
            <input class="form-control form-control-sm" type="date" id="dateOnLot" formControlName="dateOnLot" autocomplete="off">
        </div>
        <div class="form-group col-md-4 col-sm-12">
            <label for="vinNumber">VIN</label>
            <div class="input-group input-group-sm">
                <input class="form-control form-control-sm" [ngClass]="{'duplicateVINFound' : dupe}" type="text" id="vinNumber" required formControlName="vinNumber" autocomplete="off">
                <div class="input-group-append">
                    @if (vinNumber.value !== null) {
                        <button class="btn btn-dark btn-sm" type="button" [disabled]="markAsDeleted===true" (click)="decodeVIN(stockNumber.value,vinNumber.value)">Decode</button>
                    }
                    @if (vinNumber.value === null) {
                        <button class="btn btn-info btn-sm" data-target="#scanVIN" data-toggle="modal" id="btn-save-generalInformation">Scan</button>
                    }
                </div>
            </div>
            @if (dupe) {
            <div>Warning! This is a duplicate VIN.</div>
            }
        </div>
        <div class="form-group col-md-4 col-sm-12">
            <label for="stockNumber">Stock Number</label>
            <input class="form-control form-control-sm" type="text" id="stockNumber" required formControlName="stockNumber" autocomplete="off">
            @if (stockNumber.invalid) {
                <div>{{(stockNumber.errors && (stockNumber.errors.duplicateFound)) ? stockNumber.errors.duplicateFound : ''}}</div>
            }
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-4 col-sm-12">
            <label for="modelYear">Year</label>
            <input class="form-control form-control-sm" type="text" id="modelYear" formControlName="modelYear" autocomplete="off">
        </div>
        <div class="form-group col-md-4 col-sm-12">
            <label for="make">Make</label>
            <input class="form-control form-control-sm" type="text" id="make" formControlName="make" autocomplete="off">
        </div>
        <div class="form-group col-md-4 col-sm-12">
            <label for="model">Model</label>
            <input class="form-control form-control-sm" type="text" id="model" formControlName="model" autocomplete="off">
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-4 col-sm-12">
            <label for="miles">Miles</label>
            <count-input [id]="'miles'" [control]="information.get('miles')"></count-input>
        </div>
        <div class="form-group col-md-4 col-sm-12">
            <label for="odometer">Odometer</label>
            <select name="odometer" id="odometer" formControlName="odometer" class="form-control form-control-sm">
                @for (odometer of odometers; track odometer) {
                    <option [value]="odometer.value">{{odometer.name}}</option>
                }
            </select>
        </div>
        <div class="form-group col-md-4 col-sm-12">
            <label for="sellingPrice">Selling Price</label>
            <currency-input [id]="'sellingPrice'" [control]="information.get('sellingPrice')"></currency-input>
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-4 col-sm-12">
            <label for="type">Type</label>
            <select name="type" id="type" formControlName="type" class="form-control form-control-sm">
                @for (type of vehicleTypes; track type) {
                    <option [value]="type.name">{{type.name}}</option>
                }
            </select>
        </div>
        <div class="form-group col-md-4 col-sm-12">
            <label for="exteriorColor">Exterior Color</label>
            <select name="exteriorColor" id="exteriorColor" formControlName="exteriorColor" class="form-control form-control-sm">
                @for (exteriorColor of colors; track exteriorColor) {
                    <option [value]="exteriorColor.name">{{exteriorColor.name}}</option>
                }
            </select>
        </div>
        <div class="form-group col-md-4 col-sm-12">
            <label for="interiorColor">Interior Color</label>
            <select name="interiorColor" id="interiorColor" formControlName="interiorColor" class="form-control form-control-sm">
                @for (interiorColor of colors; track interiorColor) {
                    <option [value]="interiorColor.name">{{interiorColor.name}}</option>
                }
            </select>
        </div>
    </div>
</form>